module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer-shape.png
// module id = whPA
// module chunks = 17